import {
  Column,
  Columns,
  Inline,
  useResponsiveValue,
} from 'braid-design-system';
import { StatusMenu } from '../StatusMenu';
import InboxStatusButtons from '../InboxStatusButtons';
import Loader from '../../common/Loader';
import type { IJobApplication } from 'src/stores/JobApplicationStore/JobApplication';
import { observer } from 'mobx-react';
import type { Bucket } from '../../../stores/JobApplicationStore/types';

interface Props {
  statusMenuPlacement: 'top' | 'bottom';
  jobApplication: IJobApplication;
  onStatusChange: (bucket: Bucket) => Promise<void>;
}

const ActionButtons = ({
  statusMenuPlacement,
  jobApplication: { isInbox, bucket, isChangingState, id, fullName },
  onStatusChange,
}: Props) => {
  const responsiveValue = useResponsiveValue();

  if (isChangingState) {
    return <Loader marginY="small" />;
  }

  const isMobile = responsiveValue({ mobile: true, tablet: false }) ?? false;
  const responsiveActionButtons = isMobile ? (
    <Columns space="small">
      <Column>
        <Inline space="none">
          <StatusMenu
            onStatusChange={onStatusChange}
            bucket="INBOX"
            fullName={fullName}
            placement={statusMenuPlacement}
          />
        </Inline>
      </Column>
      <Column width="content">
        <InboxStatusButtons
          onStatusChange={onStatusChange}
          idPrefix={id}
          fullName={fullName}
        />
      </Column>
    </Columns>
  ) : (
    <Columns space="small">
      <Column width="content">
        <InboxStatusButtons
          onStatusChange={onStatusChange}
          idPrefix={id}
          fullName={fullName}
        />
      </Column>
      <Column>
        <Inline space="none">
          <StatusMenu
            onStatusChange={onStatusChange}
            bucket="INBOX"
            fullName={fullName}
            placement={statusMenuPlacement}
          />
        </Inline>
      </Column>
    </Columns>
  );

  return isInbox ? (
    responsiveActionButtons
  ) : (
    <StatusMenu
      onStatusChange={onStatusChange}
      bucket={bucket}
      fullName={fullName}
      placement={statusMenuPlacement}
    />
  );
};

export default observer(ActionButtons);
